/**
 * Hero Scroll Section - Interactive Controller
 * Handles sticky scroll, per-collection banners, active nav highlighting,
 * CTA updates, and clickable slides with carousel transitions.
 */

(function() {
  'use strict';
  
  // Initialize all hero scroll sections on the page
  function initHeroScroll(rootElement) {
    var spacers = Array.prototype.slice.call(rootElement.querySelectorAll('.hero-scroll__spacer'));
    var slides = Array.prototype.slice.call(rootElement.querySelectorAll('.hero-scroll__slide'));
    var headings = Array.prototype.slice.call(rootElement.querySelectorAll('[data-hero-heading]'));
    var cta = rootElement.querySelector('[data-hero-cta]');
    
    if (!spacers.length || !slides.length) return;
    
    // Set active state for slides and headings
    function setActive(index) {
      slides.forEach(function(el, i) { 
        el.classList.toggle('is-active', i === index); 
      });
      
      headings.forEach(function(h, i) { 
        h.classList.toggle('is-active', i === index);
      });
      
      // Update CTA link to match active slide
      var slide = slides[index];
      if (cta && slide && slide.getAttribute('href')) {
        cta.setAttribute('href', slide.getAttribute('href'));
      }
    }
    
    // Initialize with first slide active
    setActive(0);
    
    // Observe spacers to determine which banner should be active
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          var idx = Number(entry.target.getAttribute('data-index')) || 0;
          setActive(idx);
        }
      });
    }, { 
      threshold: 0.6,
      rootMargin: '0px'
    });
    
    spacers.forEach(function(spacer) { 
      observer.observe(spacer); 
    });
    
    // Click/keyboard navigation for headings
    headings.forEach(function(heading) {
      // Click handler
      heading.addEventListener('click', function() {
        var idx = Number(heading.getAttribute('data-index')) || 0;
        var target = spacers[idx];
        if (target) {
          target.scrollIntoView({ 
            behavior: 'smooth', 
            block: 'start' 
          });
        }
      });
      
      // Keyboard handler
      heading.addEventListener('keypress', function(e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          heading.click();
        }
      });
    });
    
    // Cleanup on section unload (for theme editor)
    return function cleanup() {
      observer.disconnect();
    };
  }
  
  // Auto-initialize all sections on page load
  function init() {
    var sections = document.querySelectorAll('[data-hero-scroll]');
    var cleanupFunctions = [];
    
    sections.forEach(function(section) {
      var cleanup = initHeroScroll(section);
      if (cleanup) cleanupFunctions.push(cleanup);
    });
    
    // Store cleanup for potential use in theme editor
    if (window.Shopify && window.Shopify.designMode) {
      window.heroScrollCleanup = function() {
        cleanupFunctions.forEach(function(fn) { fn(); });
      };
    }
  }
  
  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  
  // Re-initialize on Shopify section load (theme editor)
  if (document.addEventListener) {
    document.addEventListener('shopify:section:load', function(event) {
      var section = event.target.querySelector('[data-hero-scroll]');
      if (section) initHeroScroll(section);
    });
    
    document.addEventListener('shopify:section:unload', function() {
      if (window.heroScrollCleanup) window.heroScrollCleanup();
    });
  }
})();
